export function getDistanceOfLocation(locationA, locationB) {
  if (locationA.lat === locationB.lat && locationA.long === locationB.long) {
    return 0;
  }

  const radlat1 = (Math.PI * locationA.lat) / 180;
  const radlat2 = (Math.PI * locationB.lat) / 180;
  const theta = locationA.long - locationB.long;
  const radtheta = (Math.PI * theta) / 180;

  let dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);

  if (dist > 1) dist = 1;

  return Math.acos(dist);
}
